const contactFile = document.querySelector('.contact-form .form-group-file input');
const bookFile = document.querySelector('.book-form .form-group-file input');

function inputFile(input, text) {
    input.addEventListener('change', function() {
        const filename = this.parentNode.querySelector('input[type=file]').value.replace(/C:\\fakepath\\/i, '')

        if (filename !== '') {
            this.parentNode.parentNode.querySelector('.form-group-file__name').innerText = filename;
        } else {
            this.parentNode.parentNode.querySelector('.form-group-file__name').innerText = text;
        }
    });
}

if (document.querySelector('.page-contact')) {
    inputFile(contactFile, 'Attach file');
    inputFile(bookFile, 'Attach file');
}
